<template>
  <div class="booking-collect">
    <div class="booking-header">
      <div @click="$router.push({name: 'BookingCollectList'})">
        历史记录
      </div>
      <div
        class="booking-submit"
        @click="onConfirm"
      >
        完成
      </div>
    </div>
    <div class="booking-division" />
    <customer
      ref="customer"
      @change="customerChange"
      :readonly="submitSuccess"
    />
    <div class="booking-division" />
    <div class="booking-form">
      <van-field
        :value="addForm.product_name"
        readonly
        clickable
        rows="1"
        autosize
        type="textarea"
        label="产品库"
        input-align="right"
        @click="goPage('BookingProduct')"
        placeholder="请选择产品"
      >
        <template #button>
          <div class="booking-form-select">
            <i class="el-icon-arrow-right"></i>
          </div>
        </template>

      </van-field>
      <van-field
        v-model="addForm.pay_amount"
        label="产品价格"
        input-align="right"
        type="number"
        class="booking-placeholder-gray"
        :placeholder="addForm.product_type == 3 ? '请输入产品价格' : ''"
        :readonly="(
          addForm.product_type != 3 || 
          submitSuccess || 
          !!addForm.is_pre_product
        )"
      >

      </van-field>
    </div>
    <div class="booking-division" />
    <div
      class="booking-collect-link"
      v-if="addInfo.id"
    >
      <div @click="copy(addInfo.pay_url)">
        <img
          src="@/assets/images/booking/link.png"
          alt=""
        />
        <span>
          复制链接
        </span>
      </div>
      <div @click="goQrCode">
        <img
          src="@/assets/images/booking/code.png"
          alt=""
        />
        <span>
          生成二维码
        </span>
      </div>

    </div>

    <van-overlay
      :show="submiting"
      :z-index="9999"
    >
      <van-loading size="24px">提交中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import customer from "./components/customer.vue";
import { mapGetters } from "vuex";
import bookingService from "@/apis/booking";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";

export default {
  components: {
    customer,
  },
  computed: {
    ...mapGetters(["productInfo"]),
  },
  mixins: [enums],
  beforeRouteEnter(to, from, next) {
    next();

    // if (from.name !== "BookingProduct") {
    //   next((vm) => {
    //     vm.init();
    //   });
    // } else {
    //   next();
    // }
  },
  data() {
    return {
      submitSuccess: false,
      addForm: {},
      addInfo: {},
      submiting: false,
    };
  },
  watch: {
    productInfo: {
      handler(newVal) {
        const { addForm } = this;
        this.addForm = {
          ...addForm,
          pay_amount: newVal.product_price,
          product_id: newVal.id,
          is_pre_product: newVal.is_pre_product,
          ...newVal,
        };
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.addForm = {};
      this.$refs.customer.init();
      this.submitSuccess = false;
    },
    goQrCode() {
      const { addInfo } = this;
      this.$router.push({
        name: "BookingQrCode",
        query: {
          type: "order",
          id: addInfo.id,
          userId: this.currentUserInfo.user_id,
        },
      });
    },
    copy(content) {
      // navigator.clipboard.writeText(content);
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        Toast("复制成功");
        return navigator.clipboard.writeText(content);
      } else {
        // 创建text area
        const textArea = document.createElement("textarea");
        textArea.value = content;
        // 使text area不在viewport，同时设置不可见
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        Toast("复制成功");
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    onConfirm() {
      const { addForm, currentUserInfo, submitSuccess } = this;
      const isNum = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;

      let errMsg = "";
      if (this.submiting) return;
      if (submitSuccess) {
        errMsg = "已提交成功";
      } else if (!addForm.customer_id) {
        errMsg = "请选择客户";
      } else if (!addForm.product_id) {
        errMsg = "请选择产品";
      } else if (!addForm.pay_amount) {
        errMsg = "请填写产品价格";
      } else if (!isNum.test(addForm.pay_amount)) {
        errMsg = "请正确填写产品价格";
      }

      if (errMsg) {
        Toast(errMsg);
        return;
      }
      this.submiting = true;
      bookingService
        .orderEdit({
          ...addForm,
          create_user_id: currentUserInfo.user_id,
          create_user_name: currentUserInfo.user_name,
        })
        .then((res) => {
          this.submitSuccess = true;
          this.submiting = false;
          this.addInfo = res;
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    customerChange(customerInfo) {
      const { addForm } = this;
      addForm.customer_id = customerInfo.empi;
    },
    goPage(name) {
      if (this.submitSuccess) return;
      this.$router.push({
        name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-collect-link {
  display: flex;
  margin-top: 100px;
  justify-content: center;
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    cursor: pointer;
  }
  span {
    margin-top: 15px;
  }
  img {
    height: 80px;
    width: 80px;
    margin: 0 35px;
  }
}
</style>